import React from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import Button from 'components/Button/Button';

import { IAddBlockSectionRow } from '../AddBlockModal.types';

import { AddBlockPlaceholderTiles } from './AddBlockPlaceholderTiles';

interface IAddBlockRowProps {
  row: IAddBlockSectionRow;
  dataTestId: string;
}

export const AddBlockRow: React.FC<IAddBlockRowProps> = ({
  row,
  dataTestId
}) => {
  return (
    <div className="flex items-center gap-3 px-3 pb-2.5 pt-[14px] transition-colors hover:rounded-md hover:bg-base-primaryForeground">
      <AddBlockPlaceholderTiles />
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <span className="font-sans not-italic text-p-s font-medium text-base-primary">
            {row.title}
          </span>
          {row.badgeLabel && (
            <span className="inline-flex items-center rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase bg-indigo-100 text-indigo-700">
              {row.badgeLabel}
            </span>
          )}
        </div>
        <p className="mt-0.5 font-sans not-italic text-p-xs text-base-mutedForeground">
          {row.description}
        </p>
      </div>
      <Button
        type="button"
        variant="default"
        size="icon"
        className="shrink-0 rounded-md border-0 bg-indigo-600 text-white shadow-sm hover:bg-indigo-700 [&_i.font-awesome-icon]:!text-sm"
        aria-label={`Add ${row.title}`}
        onClick={row.onAdd}
        dataTestId={`${dataTestId}-add`}
      >
        <FontAwesomeIcon icon="fa-regular fa-plus" />
      </Button>
    </div>
  );
};
